import { render, staticRenderFns } from "./ProductionScanIndex.vue?vue&type=template&id=bfdfc154&"
import script from "./ProductionScanIndex.vue?vue&type=script&lang=js&"
export * from "./ProductionScanIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports